/**
 * Local-only dev-auth fixture: the account-code/grants identity read from
 * localStorage that stands in for a Cognito session, and the request
 * headers it drives. The `process.env.NODE_ENV` gate is evaluated once
 * here, at module scope, so the production build folds every branch behind
 * it away.
 */
import type { Client } from 'connectors/ams/client';

const DEV_GRANTS_STORAGE_KEY = 'X-AMS-Dev-Grants';
const DEV_HEADER_NAMES = ['X-AMS-Dev-Account-Code', DEV_GRANTS_STORAGE_KEY] as const;

const DEV_MODE = process.env.NODE_ENV === 'development' && typeof window !== 'undefined';

export function installDevAuthHeaders(client: Client): void {
  if (!DEV_MODE) {
    return;
  }

  client.interceptors.request.use((request) => {
    for (const headerName of DEV_HEADER_NAMES) {
      const value = localStorage.getItem(headerName);
      if (value) {
        request.headers.set(headerName, value);
      }
    }
    return request;
  });
}

export function hasDevIdentity(): boolean {
  return DEV_MODE && Boolean(localStorage.getItem(DEV_GRANTS_STORAGE_KEY));
}
